/**
 * This converts number (between 0 - 1) to equivalent percentage value
 * @param number
 * @returns {string}
 */
import { DEFAULT_LOCALE } from '@/constants/common'

export default number => {
  const option = {
    style: 'percent',
    maximumFractionDigits: 2
  }
  const formatter = new Intl.NumberFormat(DEFAULT_LOCALE, option)
  return formatter.format(number)
}
